module.exports = __webpack_public_path__ + "img/PD1506174260601815040.3ce6b4ab.png";